<template>
  <a
    class="relative block px-12 py-2 text-base text-gray-dark hover:bg-blue-highlight md:px-6 md:text-sm"
    href="#"
    @click.prevent="$emit('click')"
  >
    <slot />
  </a>
</template>
